import View from './view';
import {RequestResponsePayload} from '../../../../../../shared/models/api';

export const RequestsTable = ({requests}: {requests: RequestResponsePayload[]}) => {
  return View({requests});
};
